import React from "react";
import { useState } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { fetchDeveloperToolsQueryDatabase } from "../../../services/api-raindrop";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";

const PanelDatabaseInput = ({
  inputText,
  setInputText,
  onSubmit,
  errorMessage,
}) => {
  return (
    <div
      className={`flex flex-col gap-4 w-full max-w-lg h-full items-center justify-center p-4 rounded-lg border
      dark:bg-color-dark-background-secondary bg-color-background-secondary
      dark:border-color-dark-border-secondary border-color-border-secondary
      
      `}
    >
      <textarea
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        placeholder={"SELECT\n\t*\nFROM nimbus_organisation\nLIMIT 1;"}
        className={`max-w-4xl w-full h-full rounded-lg p-4  border
        dark:placeholder:text-color-dark-text-tertiary placeholder:text-color-text-tertiary
        dark:bg-color-dark-background-tertiary bg-color-background-tertiary
        dark:border-color-dark-border-tertiary border-color-border-tertiary
        dark:text-color-dark-text-primary text-color-text-primary`}
      ></textarea>
      <div className="flex flex-col justify-end items-end w-full">
        <RaindropButton
          title={"Submit"}
          onClick={onSubmit}
          style={ButtonStyle.Primary}
        />

        {errorMessage && (
          <div className="text-red-500 text-xs">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

const PanelDatabaseOutput = ({ response }) => {
  return (
    <div
      className={`flex flex-col max-w-lg w-full gap-4 h-full  rounded-lg text-left
    
    `}
    >
      <JSONBlob data={response} />
    </div>
  );
};

const NimbusDeveloperToolsDatabase = () => {
  const [inputText, setInputText] = useState(
    "SELECT\n\t*\nFROM raindrop_organisation\nLIMIT 1"
  );
  const [response, setResponse] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const onSubmit = () => {
    fetchDeveloperToolsQueryDatabase({ query: inputText })
      .then((res) => {
        setResponse(res.results);
        setErrorMessage(null);
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  };

  return (
    <div className="flex flex-row gap-2 justify-around w-full h-full overflow-scroll items-center p-6 ">
      <PanelDatabaseInput
        inputText={inputText}
        setInputText={setInputText}
        onSubmit={onSubmit}
        errorMessage={errorMessage}
      />
      <PanelDatabaseOutput response={response} />
    </div>
  );
};

export default NimbusDeveloperToolsDatabase;
